import React, { useState, useEffect } from "react";
import api from "../../../api";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

const EditPackage = () => {
  const { packageId } = useParams();
  const navigate = useNavigate();

  const [packageData, setPackageData] = useState({
    packageName: "",
    packageType: "Subscription",
    amount: "",
    transactionFee: "",
    validity: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  useEffect(() => {
    api
      .get(`/admins/packagelist/get/${packageId}`)
      .then((res) => {
        setPackageData(res.data);
        setLoading(false);
      })
      .catch(() => {
        setError("Error fetching package data");
        setLoading(false);
      });
  }, [packageId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPackageData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...packageData,
      totalPackageAmount:
        parseFloat(packageData.amount || 0) +
        parseFloat(packageData.transactionFee || 0),
    };

    try {
      await api.put(`/admins/packagelist/put/${packageId}`, payload);
      setSuccess("Package updated successfully");
      setError("");
    } catch {
      setError("Error updating package");
      setSuccess("");
    }
  };

  if (loading) return <div className="text-center">Loading...</div>;

  const totalAmount =
    parseFloat(packageData.amount || 0) +
    parseFloat(packageData.transactionFee || 0);

  return (
    <div className="container mt-5">
      <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
        <FaArrowLeft /> Back
      </button>

      <h2>Edit Package</h2>

      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Package Name</label>
          <input
            className="form-control"
            name="packageName"
            value={packageData.packageName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Package Type</label>
          <select
            className="form-select"
            name="packageType"
            value={packageData.packageType}
            onChange={handleChange}
          >
            <option value="Subscription">Subscription</option>
          </select>
        </div>

        <div className="mb-3">
          <label>Package Amount</label>
          <input
            type="number"
            className="form-control"
            name="amount"
            value={packageData.amount}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Transaction Fee</label>
          <input
            type="number"
            className="form-control"
            name="transactionFee"
            value={packageData.transactionFee}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label>Total Package Amount</label>
          <input
            type="number"
            className="form-control"
            value={totalAmount.toFixed(2)}
            readOnly
          />
        </div>

        <div className="mb-3">
          <label>Validity (Days)</label>
          <input
            type="number"
            className="form-control"
            name="validity"
            value={packageData.validity}
            onChange={handleChange}
            required
          />
        </div>

        <button className="btn btn-primary">Update Package</button>
      </form>
    </div>
  );
};

export default EditPackage;
